export default __webpack_public_path__ + "static/video-stub-2920161069f66866869ebf494abbaa74.png";